import React from "react";

import { Value } from "lib/build/schema";

import { api } from "src/common/utils/api";
import { useCreateGenericError } from "src/features/notifications";

interface Payload {
	token: string;
	title?: string;
	firstName: string;
	lastName: string;
	phoneNumber: string;
	occupation: string;
	stampNumber?: string;
	defaultLanguage: string;
	password: string;
}

export function useSignUp(
	token: string,
	value: Value,
	isValid: boolean
): { isSubmitted: boolean; isLoading: boolean; onSubmit(): void } {
	const createGenericError = useCreateGenericError();

	const [{ isSubmitted, isLoading }, setState] = React.useState({
		isSubmitted: false,
		isLoading: false
	});

	const signUp = React.useCallback(
		async ({
			title,
			firstName,
			lastName,
			phoneNumber,
			occupation,
			stampNumber,
			defaultLanguage,
			password
		}: Payload) => {
			setState(state => ({ ...state, isLoading: true }));
			try {
				await api.post("/authflow/register", {
					token,
					title,
					firstName,
					lastName,
					phoneNumber,
					occupation,
					stampNumber,
					defaultLanguage,
					password
				});
				setState(state => ({ ...state, isLoading: false }));
				redirectToHome();
			} catch {
				setState(state => ({ ...state, isLoading: false }));
				createGenericError();
			}
		},
		[token, createGenericError]
	);

	const onSubmit = (): void => {
		setState(state => ({ ...state, isSubmitted: true }));
		if (isValid) {
			signUp(value);
		}
	};

	return {
		isSubmitted,
		isLoading,
		onSubmit
	};
}

function redirectToHome(): void {
	window.location.href = "/";
}
